import { codesNoSDK, sdkGeneric, sdkIncompatibilityErrors, DEVICE_DESKTOP, DEVICE_MOBILE } from "../Constants/Constants"
import { generateJWE } from '../../shared/Utilities/cryptoUtils'

export const getInternalCode = (errorCode, codesList) => {
    if(codesList[errorCode]){
        return codesList[errorCode]
    }else if(sdkGeneric[errorCode]){
        return sdkGeneric[errorCode]
    } else{
        return codesNoSDK.unknownError
    }
}

export const getErrorModalText = errorData => sdkIncompatibilityErrors[errorData] || sdkIncompatibilityErrors['DEFAULT'];

export const getBodyValidateUser = async context => {
    return { data: { data: context.data, key: context.jweKey}};
}

export const getBodyActivateUser = async context => {
    const data = { data: context.data }
    return { data: data};
}

export const getBodyValidateTransaction = async context => {
    const data = { data: context.data }
    return { data: data};
}

export const getBodyUpdateRetry = async context => {
    const data = { key: context.jweKey, data: context.encryptedDataClient, id: context.ivClient }
    return { data: data};
}

export const getBodyLogs = async (context, sourceId, origin, result, description = "") => {
    const customerTransaction = context.customerTransactionUrl || context.customerTransaction;
  
    const handleLogging = async (codeLog, additionalField) => {
      const dataRequest = getSaveLogsBody({ context, sourceId, codeLog, customerTransaction, additionalField });
      const jweRequest = await generateJWE(dataRequest, context.bffKey);
      return { data: jweRequest };
    };
  
    try {
      const bioCode = getInternalCode(result.code, origin);
      const additionalField = getAdditionalData(result, bioCode, description);
      return await handleLogging(bioCode.codeLog, additionalField);
    } catch (error) {
      const additionalField = JSON.stringify(result);
      return handleLogging(codesNoSDK.unknownError.codeLog, additionalField);
    }
  };

const getAdditionalData = (result, bioCode = {}, description = '') => {
    const message = result?.message || result;

    if (bioCode.codeLog === codesNoSDK.unknownError.codeLog) {
        return result;
    }

    try {
        return description ? JSON.stringify(description) : message;
    } catch {
        return description || message;
    }
};

const getSaveLogsBody = ({context, sourceId, codeLog, customerTransaction, additionalField }) => {
    const data = {
      documentType: context.documentType,
      documentNumber: context.documentNumber,
      sessionId: context.sessionId,
      channel: context.clientId,
      module: sourceId,
      codeLog: codeLog,
      customerTransaction,
      additionalInfo: buildAdditionalInfo(context,additionalField)
    };
    return JSON.stringify(data)
  };

  const buildAdditionalInfo = (context, additionalField) => {
    const rawData = JSON.stringify(additionalField ?? {});
    const sanitizedData = rawData.replace(/[\\"]/g, "");
    if (!sanitizedData) {
        return "";
    }
  
    return context.isRedirect
      ? `customer_code:${sanitizedData}`
      : `message:${sanitizedData}`;
  };

export const hasCameraPermissions = async () => {
    if (!navigator.mediaDevices || typeof navigator.mediaDevices.enumerateDevices !== 'function') {
        return false;
    }

    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        return devices.some(device => device.kind === 'videoinput' && device.deviceId);
    } catch (_error) {
        return false;
    }
}

export const requestCameraPermission = async () => {
    try {
        await navigator.mediaDevices.getUserMedia({ video: true })
        return {result: true}
    } catch (error) {
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
            return {result: false, denied: true}
        }
        return { 
            result: false, 
            denied: false, 
            error: error.message || 'Unknown error'
        };
    }
}

export const getDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return DEVICE_MOBILE;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return DEVICE_MOBILE;
    }
    return DEVICE_DESKTOP;
}
  